"use client";

import { KidsGroups, UiKidsGroup } from "@jesus-central-church/ui";
import { SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import { SbKidsGroupCollection } from "@storyblok/types/287435740670216/storyblok-components";

export function KidsGroupCollectionComponent({
  blok,
}: {
  blok: SbKidsGroupCollection;
}) {
  const kidsGroups: UiKidsGroup[] =
    blok.kidsGroups?.map((group) => ({
      name: group.name,
      ageRange: group.ageRange,
      icon: group.icon?.filename || "",
      description: group.description,
    })) ?? [];

  return (
    <div
      {...storyblokEditable(blok as SbBlokData)}
      className={`bg-${blok.backgroundColor as string}`}
    >
      <KidsGroups groups={kidsGroups} variant="carousel" />
    </div>
  );
}
